import React, { useEffect, useState } from "react";

const BodyPart = (props) => {
    const { isChiefComplain, vasQuestionHandler, imageSide, styleName, imageLink, showFirst } = props
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            if (innerWidth !== window.innerWidth) {
                setInnerWidth(window.innerWidth);
            }

        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div
            className={`mmh-body-part body-height box body-part__container ${(showFirst || innerWidth > 720) ? ' body-part__container--visible ' : ' body-part__container--hidden '}`}>
            <div className="body-part__skeleton-wrapper body_cont height-inherite">
                <svg data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={(e) => vasQuestionHandler(e)}
                    tabIndex="0"
                    role="button"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 381 944"
                    className={`skeleton_svg outline-none ${styleName} z-index-1 ${isChiefComplain ? "chief-complain-body" : ''}`}
                >
                    {/*<image xlinkHref={imageLink}/>*/}
                    <image href={imageLink} />
                    {/*<image width="381" height="944" xlinkHref={imageLink}/>*/}
                    {props.children}
                </svg>
                <span
                    className={`body-part__indicator ${isChiefComplain ? 'chief-complain-body-indicator' : ''}`}
                    style={{
                        position: 'absolute',
                        bottom: '30%',  /* Position at the bottom to avoid overlap */
                        width: '85%',
                        // left: '0',
                        pointerEvents: 'none'
                    }}>
                    <span className='body-point-text margin-left'>
                        {imageSide.toLowerCase() === 'front' ? 'RIGHT' : 'LEFT'}
                    </span>
                    <span className='body-point-text margin-right'>
                        {imageSide.toLowerCase() === 'front' ? 'LEFT' : 'RIGHT'}
                    </span>
                </span>
            </div>

            <div className="body-part__list-wrapper">
                {props.pointListComponent}
            </div>
        </div>
    )
}

export default BodyPart
